import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import SubscriptionPage from "./ui";

const Subscription = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <SubscriptionPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default Subscription;

